import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M17.5 19h-16C.673 19 0 18.327 0 17.5v-16C0 .673.673 0 1.5 0h16c.827 0 1.5.673 1.5 1.5v16c0 .827-.673 1.5-1.5 1.5zM1.5 1c-.276 0-.5.224-.5.5v16c0 .276.224.5.5.5h16c.276 0 .5-.224.5-.5v-16c0-.276-.224-.5-.5-.5h-16z',
    'M5 15a.4963.4963 0 01-.334-.128.4998.4998 0 01-.037-.706l9-10c.185-.205.501-.222.706-.037s.222.501.037.706l-9 10a.4987.4987 0 01-.372.166V15zM6.5 9C5.122 9 4 7.878 4 6.5S5.122 4 6.5 4 9 5.122 9 6.5 7.878 9 6.5 9zm0-4C5.673 5 5 5.673 5 6.5S5.673 8 6.5 8 8 7.327 8 6.5 7.327 5 6.5 5zM12.5 15c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5zm0-4c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z',
  ],
  height: 20,
  width: 20,
});
